import axios from '@/libs/http';

export const getPayUrl = (no)=>{
    return axios.request({
        url: '/generalPayment/getAlipayUrl',
        params:{
            no
        },
        method: 'get'
    })
}

export const queryOrderStatus = (no) =>{
    return axios.request({
        url: '/generalPayment/getStatus',
        params:{
            no
        },
        method: 'get'
    })
}
